import { useEffect } from "react";
import { useBookingEngine } from "./context/BookingEngineContext";

const loadFontDynamically = (textsFont: string | undefined) => {
  if (textsFont && !document.querySelector(`link[data-font="${textsFont}"]`)) {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(
      textsFont
    )}&display=swap`;
    link.setAttribute("data-font", textsFont);
    document.head.appendChild(link);
  }
};

export const breakpoints = {
  xs: "480px",
  sm: "768px",
  md: "1024px",
  lg: "1280px",
  xl: "1440px",
};

export const useLightTheme = () => {
  const { bookingEngineData } = useBookingEngine();
  const textsFont = bookingEngineData?.textsFont || "Poppins, sans-serif";
  const headFont = bookingEngineData?.headersFont || "Poppins, sans-serif";

  useEffect(() => {
    loadFontDynamically(bookingEngineData?.textsFont);
  }, [bookingEngineData?.textsFont]);

  return {
    colors: {
      primary: bookingEngineData?.accentColor || "#5F7EFB", // Fallback to default if accentColor is undefined
      primary30: `${bookingEngineData?.accentColor || "#5F7EFB"}30`,
      secondary: "#FF5722",
      black: "#272727",
      background: "#F7F7FA",
      backgroundOpacity: "#F7F7FA30",
      backgroundOpacity90: "#F7F7FA99",
      card: "#FFFFFF",
      text: "#000000",
      button: bookingEngineData?.accentColor || "#000000",
      buttonFont: "#FFFFFF",
      skeletonBackground: "#e6e6ee",
      skeletonPulse: "#CCCCCC",
      avatar: "#FFFFFF",
      bubble: "#ffffff",
      bubbleOutgoing: bookingEngineData?.accentColor || "#272727",
    },
    typography: {
      textsFont,
      headFont,
    },
    boxShadows: {
      light: "0px 4px 8px rgba(0, 0, 0, 0.08)",
    },
    breakpoints: {
      xs: "480px",
      sm: "768px",
      md: "1024px",
      lg: "1280px",
      xl: "1440px",
    },
  };
};

export const useDarkTheme = () => {
  const { bookingEngineData } = useBookingEngine();
  const textsFont = bookingEngineData?.textsFont || "Poppins, sans-serif";
  const headFont = bookingEngineData?.headersFont || "Poppins, sans-serif";

  useEffect(() => {
    loadFontDynamically(bookingEngineData?.textsFont);
  }, [bookingEngineData?.textsFont]);
  return {
    colors: {
      primary: bookingEngineData?.accentColor || "#5F7EFB",
      primary30: `${bookingEngineData?.accentColor || "#5F7EFB"}30`,
      secondary: "#FF5722",
      black: "#FFFFFF",
      background: "#171717",
      backgroundOpacity: "#17171730",
      backgroundOpacity90: "#17171799",
      card: "#272727",
      text: "#FFFFFF",
      button: bookingEngineData?.accentColor || "#272727",
      buttonFont: "#ffffff",
      skeletonBackground: "#272727",
      skeletonPulse: "#e0e0e0",
      avatar: "#272727",
      bubble: "#272727",
      bubbleOutgoing: bookingEngineData?.accentColor || "#272727",
    },
    typography: {
      textsFont,
      headFont,
    },
    boxShadows: {
      dark: "0px 4px 20px rgba(96, 121, 251, 0.12)",
    },
    breakpoints: {
      xs: "480px",
      sm: "768px",
      md: "1024px",
      lg: "1280px",
      xl: "1440px",
    },
  };
};

export const guidebookCollapseTokens = {
  lineHeight: 1.6,
  controlHeight: "44px",
  gap: "8px",
  emphasisWidth: "2px",
  focusWidth: "2px",
  focusOffset: "3px",
};
